class CTCartNoticeTimer {
  constructor(element) {
    this.element = element;
    this.output = element.querySelector('[data-ct-cart-timer-output]');
    this.durationMinutes = Number(element.dataset.duration || 10);
    this.storageKey = 'ct-cart-notice-timer-end';

    if (!this.output || !Number.isFinite(this.durationMinutes)) return;

    this.initialize();
  }

  initialize() {
    const now = Date.now();
    let endTime = Number(sessionStorage.getItem(this.storageKey));

    if (!endTime || endTime <= now) {
      endTime = now + this.durationMinutes * 60 * 1000;
      sessionStorage.setItem(this.storageKey, String(endTime));
    }

    this.endTime = endTime;
    this.render();

    this.interval = window.setInterval(() => {
      this.render();
    }, 1000);
  }

  render() {
    const remainingMilliseconds = Math.max(0, this.endTime - Date.now());
    const remainingSeconds = Math.floor(remainingMilliseconds / 1000);

    const minutes = Math.floor(remainingSeconds / 60);
    const seconds = remainingSeconds % 60;

    this.output.textContent =
      `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;

    if (remainingSeconds === 0 && this.interval) {
      window.clearInterval(this.interval);
    }
  }
}

class CTCartPreviewModal {
  constructor(modal) {
    this.modal = modal;
    this.dialog = modal.querySelector('.ct-cart-preview-modal__dialog');
    this.image = modal.querySelector('[data-ct-cart-preview-image]');
    this.title = modal.querySelector('[data-ct-cart-preview-title]');
    this.lastTrigger = null;

    this.bindEvents();
  }

  bindEvents() {
    document.addEventListener('click', (event) => {
      const openButton = event.target.closest('[data-ct-cart-preview-open]');

      if (openButton) {
        event.preventDefault();
        this.open(openButton);
        return;
      }

      const closeButton = event.target.closest('[data-ct-cart-preview-close]');

      if (closeButton && this.modal.contains(closeButton)) {
        event.preventDefault();
        this.close();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !this.modal.hidden) {
        this.close();
      }
    });
  }

  open(trigger) {
    const imageSource = trigger.dataset.previewSrc;
    const imageAlt = trigger.dataset.previewAlt || '';
    const productTitle = trigger.dataset.previewTitle || 'Product preview';

    if (!imageSource) return;

    this.lastTrigger = trigger;

    this.image.src = imageSource;
    this.image.alt = imageAlt;
    this.title.textContent = productTitle;

    this.modal.hidden = false;
    document.body.classList.add('ct-cart-preview-is-open');

    window.requestAnimationFrame(() => {
      this.dialog.focus();
    });
  }

  close() {
    this.modal.hidden = true;
    document.body.classList.remove('ct-cart-preview-is-open');

    this.image.src = '';
    this.image.alt = '';

    if (this.lastTrigger) {
      this.lastTrigger.focus();
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-ct-cart-timer]').forEach((element) => {
    new CTCartNoticeTimer(element);
  });

  const previewModal = document.querySelector('[data-ct-cart-preview-modal]');

  if (previewModal) {
    new CTCartPreviewModal(previewModal);
  }
});